import * as React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    noDecimals?: boolean; // Propiedad adicional para no permitir decimales
    noThousandSeparator?: boolean; // Propiedad adicional para no permitir separador de miles
    maxLength?: number;
}

export const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
    function NumericFormatCustom(props, ref) {
        const { onChange, maxLength = 10, noDecimals, noThousandSeparator, ...other } = props;

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                allowNegative={false}
                allowLeadingZeros={true}
      
         

                maxLength={maxLength}
                thousandSeparator={false} // No permitir separador de miles si noThousandSeparator es true
                decimalSeparator={noDecimals ? "!" : ","} // No permitir decimales si noDecimals es true
                valueIsNumericString
                prefix=""
            />
        );
    },
);
